'use strict';

const React = require('react');
//const PropTypes = require('prop-types');
const _ = {
    clone: require('lodash/clone'),
    reject: require('lodash/reject'),
};

const ShortCourseUtil = require('../../../../../app/shared/ShortCourseUtil');

const ShortCourseEditorActions = require('../../../actions/ShortCourseEditorActions');
const ShortCourseEditorStore = require('../../../stores/ShortCourseEditorStore');

class ValidationSidebar extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            dirty: false,
            validation: this.getValidation()
        };
        this.unsubscribes = [
            ShortCourseEditorStore.listen(this.onStoreChange),
        ];
    }
    
    getValidation=()=>{
        var validation = ShortCourseUtil.validateShortCourse(this.props.data);
        var rawComments = this.props.commentInfo && this.props.commentInfo.shortCourseComments;
        validation.unresolvedComments = _.reject(rawComments,{status: 'RESOLVED'});
        return validation;
    }
    
    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }
    
    onStoreChange=()=>{
        if (!this.state.dirty) {
            this.setState({
                dirty: true
            });
        }
    }
    
    refreshValidation=()=>{
        if (this.props.refreshComments) { 
            this.props.refreshComments();
        }
        this.setState({
            dirty: false,
            validation: this.getValidation(),
        });
    }
    
    goToNav=(nav)=>{
        if (nav) {
            ShortCourseEditorActions.goToLocation(nav);
        }
    }
    
    render() {
        return (
            <div className="validation-sidebar-content">
                <button 
                    onMouseOver={null/*(evt)=>{Actions.onMouseOverHelpHandler('validation-refresh-button',evt)}*/}
                    onClick={this.refreshValidation}>refresh</button>
                <div className="validation-section">
                    <h1>Errors</h1>
                    {this.state.validation.errors.length ?
                        this.state.validation.errors.map((elem,index)=>{return(
                        <p className="error-text" key={index} role={elem.location ? "button" : ""} 
                            onMouseOver={null/*(evt)=>{Actions.onMouseOverHelpHandler('validation-nav-button',evt)}*/}
                            onClick={()=>{this.goToNav(elem.location)}}>{elem.message}</p>
                        )})
                    : 
                    <p className="good-text">{'no errors.'}</p>
                    }
                </div>
                
                <div className="validation-section">
                    <h1>Warnings</h1>
                    {this.state.validation.warnings.length ?
                        this.state.validation.warnings.map((elem,index)=>{return(
                        <p className="warning-text" key={index} role={elem.location ? "button" : ""} 
                            onMouseOver={null/*(evt)=>{Actions.onMouseOverHelpHandler('validation-nav-button',evt)}*/}
                            onClick={()=>{this.goToNav(elem.location)}}>{elem.message}</p>
                        )})
                    : 
                        <p className="good-text">{'no warnings.'}</p>
                    }
                </div>

                <div className="validation-section">
                    <h1>Messages</h1>
                    {this.state.validation.messages.length ?
                        this.state.validation.messages.map((elem,index)=>{return(
                        <p key={index} role={elem.location ? "button" : ""} 
                            onMouseOver={null/*(evt)=>{Actions.onMouseOverHelpHandler('validation-nav-button',evt)}*/}
                            onClick={()=>{this.goToNav(elem.location)}}>{elem.message}</p>
                        )})
                    : 
                        <p className="neutral-text">{'no messages.'}</p>
                    }
                </div>
                
                {this.state.validation.unresolvedComments.length ?
                <div className="validation-section">
                    <h1>Unresolved Comments</h1>
                    {this.state.validation.unresolvedComments.map((elem,index)=>{return(
                    <p className="warning-text" key={index} role={elem.location ? "button" : ""} 
                        onMouseOver={null/*(evt)=>{Actions.onMouseOverHelpHandler('validation-nav-button',evt)}*/}
                        onClick={()=>{this.goToNav(elem.location)}}>{elem.comment}</p>
                    )})}
                </div>
                : null }
                
            </div>
        )
    }
}; // ValidationSidebar


module.exports = ValidationSidebar;

